import { NgModule } from '@angular/core';
import { serviceMapFactory } from '@spartacus/core';
import { ShimanoBusinessTypeService } from '../service/businessType/shimano-business-type.service';
import { ShimanoCountryService } from '../service/country/shimano-country.service';
import { ShimanoLanguageService } from '../service/language/shimano-language.service';

export function shimanoServiceMapFactory() {
  return {
    ...serviceMapFactory(),
    shimanoBusinessType: ShimanoBusinessTypeService,
    shimanoCountry: ShimanoCountryService,
    shimanoLanguage: ShimanoLanguageService,
  };
}

/**
 * Demonstrates stateful routing parameters in the URL, by adding
 * the site, language and currency to the URL.
 */
@NgModule({
  imports: [],
  providers: [],
  declarations: [],
  exports: [],
})
export class MultiSiteModule {}
